<template>
  <div class="brandlogo">
    <img
      src="../assets/image/evtools.png"
      alt="EVtools"
    >
    <span
      v-if="context !== 'login'"
      class="logo-sub"
    >
      workflow
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    context: {
      type: String,
      default: 'login'
    }
  },
  computed: {
    ...mapGetters('tenant', ['getTenant']),
    img() {
      return this.context === 'login' ? 'evtools' : this.getTenant.slug;
    },
   
    color() {
      return 'none';
    }
  }
};
</script>

<style lang="scss">
.brandlogo {
  position: relative;
  margin-top: calc(-0.2 * #{$menu-height});
  img {
    height: $menu-height;
  }
  .logo-sub {
    font-size: calc(0.2 * #{$menu-height});
    color: $gray-500;
    position: absolute;
    bottom: calc(0.02 * #{$menu-height});
    right: calc(0.25 * #{$menu-height});
  }
}
</style>
